<template>
    <v-card>
        <v-snackbar v-model="snackbar" multi-line :timeout="4000" top vertical> {{ snackBarText }}
            <v-btn color="pink" outlined @click="snackbar = false"> Cerrar
            </v-btn>
        </v-snackbar>
        
            <v-card color="grey lighten-5" class="mx-auto" min-width="500" >
                 <v-card-title
                    class="blue-grey lighten-3 white--text"
                >
                <span class="title">Job Id: {{ticket}}</span>
                    <v-row >
                        <v-col xs="12"  sm="8" md="2">
                            <v-btn class="ma-2 white--text" tile  color="blue" @click="dialogDetail=true" v-if="isDoing && isWorker">
                                <v-icon left color="white">far fa-edit</v-icon> Update Detail
                            </v-btn>
                        </v-col>
                        <v-col xs="12"  sm="4" md="2">
                            <v-btn class="ma-2" tile  color="error" @click="finishTask()" v-if="isDoing && isWorker">
                                <v-icon left>fas fa-hourglass-end</v-icon> Finish Job
                            </v-btn>
                            <v-btn class="ma-2" tile  color="error" @click="startTask()" v-if="isTodo && isWorker">
                                <v-icon left>fas fa-hourglass-start</v-icon> Start Job
                            </v-btn>
                        </v-col>
                    </v-row>
                 </v-card-title> 
                <v-container >
                    <v-timeline align-top :dense="$vuetify.breakpoint.smAndDown">
                        <v-timeline-item icon="far fa-registered" fill-dot>
                            <v-card color="red lighten-2" >
                                <v-card-title class="title">Job Register</v-card-title>
                                <v-card-text class="white text--primary">
                                    <v-row justify="space-between">
                                        <v-col>
                                            This task was registered on {{ RegisterDate}}
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-simple-table dense>
                                                <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                    <th class="text-left">Proporty</th>
                                                    <th class="text-left">Value</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>Date</td>
                                                        <td>{{infoTicket.date}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Start Time</td>
                                                        <td>{{infoTicket.startTime}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Customer</td>
                                                        <td>{{customer.name}}</td>
                                                    </tr>
                                                        <tr>
                                                        <td>Location</td>
                                                        <td>{{infoTicket.location}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>PO#</td>
                                                        <td>{{detail.po}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Description</td>
                                                        <td>{{detail.description}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Trucking Co.</td>
                                                        <td> {{detail.trucking_Co}} </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Truck #</td>
                                                        <td> {{detail.truck}} </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Trailer #</td>
                                                        <td> {{detail.trailer}} </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Container size </td>
                                                        <td> {{detail.containerSize}} </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Driver</td>
                                                        <td> {{detail.driver}} </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Authorized By</td>
                                                        <td> {{detail.authorizedBy}} </td>
                                                    </tr>
                                                    <tr>
                                                        <td>{{detail.otherField}}</td>
                                                        <td> {{detail.otherFieldValue}} </td>
                                                    </tr>
                                                </tbody>
                                                </template>
                                            </v-simple-table>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                                <v-card-actions>
                                    <p> User: {{infoTicket.userRegister}} </p>
                                </v-card-actions>
                            </v-card>   
                        </v-timeline-item>
                        <!-- Card to assigment worker-->
                        <v-timeline-item icon="fas fa-hands-helping" fill-dot>
                            <v-card color="deep-purple lighten-4" >
                                <v-card-title class="title">Assigned Lumpers</v-card-title>
                                <v-card-text class="white text--primary">
                                    <ul id="workers">
                                        <li v-for="(item, index) in infoTicket.workersAssigment" :key="index">
                                            {{ item.userName }}
                                        </li>
                                    </ul>
                                </v-card-text>
                                <v-card-actions>
                                    <p> User: {{infoTicket.userRegister}} </p>
                                </v-card-actions>
                            </v-card>
                        </v-timeline-item>
                        <v-timeline-item
                            v-for="(item, i) in infoTicket.tickeLogDTOs" :key="i" color="pink darken-2" icon="fas fa-people-carry" fill-dot >
                            <v-card :color="getRandomColor()" dark >
                                <v-card-title class="title">Activity Task</v-card-title>
                                <v-card-text class="white text--primary">
                                    <v-row justify="space-between">
                                        <v-col>
                                            {{item.description}} on {{ RegisterDateLog(item.date)}}
                                        </v-col>
                                    </v-row>
                                    <v-row align="center" justify="center" v-if="item.filesTravels != null">
                                        <v-col v-for="n in item.filesTravels" :key="n.idFile"  cols="12" sm="4" md="4">
                                            <v-img :src="`${n.path}`" aspect-ratio="1" class="grey lighten-2" @click="showImg(n.path)" max-height="70" max-width="70">
                                            <template v-slot:placeholder>
                                                <v-row class="fill-height ma-0" align="center" justify="center">
                                                    <v-progress-linear indeterminate color="grey lighten-5"></v-progress-linear>
                                                </v-row>
                                            </template>
                                            </v-img>
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="item.comentaryTravel != null" >
                                        <div class="subTitle-card">
                                            <v-divider color="primary"></v-divider>
                                            Comentary:  {{item.comentaryTravel.comentary}} </div>
                                    </v-row>
                                </v-card-text>
                                    <v-card-actions>
                                    <p> User: {{item.userName}} </p>
                                </v-card-actions>
                            </v-card>
                            </v-timeline-item>
                    </v-timeline>
                </v-container>
            </v-card>
        
        <!--FINISHIN TASK -->
        <div class="text-center">
            <v-bottom-sheet v-model="sheet" inset>
            <v-sheet class="text-center">
                <v-row>
                    <v-col cols="12" sm="6" md="12">
                     <v-textarea v-model="comentary" prepend-icon="comment" label="Worker Notes" auto-grow outlined rows="4" row-height="25" shaped ></v-textarea>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                        <v-file-input
                            v-model="files"
                            color="deep-purple accent-4"
                            counter
                            label="File input"
                            multiple
                            prepend-icon="photo_library"
                            outlined
                            :show-size="1000">
                            <template v-slot:selection="{ index, text }">
                            <v-chip v-if="index < 2" color="deep-purple accent-4" dark label small >
                                {{ text }}
                            </v-chip>
                            <span v-else-if="index === 2" class="overline grey--text text--darken-3 mx-2" >
                                +{{ files.length - 2 }} File(s)
                            </span>
                            </template>
                        </v-file-input>
                    </v-col>
                </v-row> 
                <v-btn :loading="loading3" :disabled="loading3" color="blue-grey" class="ma-2 white--text" @click="save()" >
                    Save
                    <v-icon right dark>fas fa-save</v-icon>
                </v-btn>
            </v-sheet>
            </v-bottom-sheet>
        </div>
        <showImg :src="src" :dialog="dialog" @showDialog="showImg()" />
        <v-dialog v-model="dialogDetail" transition="dialog-bottom-transition"
            max-width="600">
            <v-toolbar
              color="primary"
              dark
            >Update Detail</v-toolbar>
            <v-card>
                <v-container>
                <v-form >
                        <v-row>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field disabled  v-model="detail.po" label="PO" ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field  v-model="detail.truck" label="Truck" ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field disabled  v-model="detail.trucking_Co" label="Trucking CO" ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field  v-model="detail.trailer" label="Trailer" ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field  v-model="detail.containerSize" label="Container size" ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="5">
                                <v-text-field  v-model="detail.description" label="Description" ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field  v-model="detail.driver" label="Driver" ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field disabled  v-model="detail.authorizedBy" label="Authorized By" ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field disabled  v-model="detail.otherField" label="Field Name" ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field disabled  v-model="detail.otherFieldValue" label="Field Value" ></v-text-field>
                            </v-col>
                        </v-row>
                </v-form>
                </v-container>
                <v-card-actions class="justify-end">
              <v-btn outlined color="success" text @click="updateDetail()" >Save</v-btn>
              <v-btn outlined color="error" text @click="dialogDetail = false" >Cancel</v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
    import moment from 'moment'
    import {showMessageError,showMessageSuccess,showMessageWarning} from '../../services/sweetAlert'
    import { Component, Prop } from 'vue-property-decorator';
    import { format } from 'date-fns'
    import { mapGetters } from 'vuex'
    import { AxiosResponse } from 'axios'
    import showImg from './showImg.vue'
export default{
    data() {
        return {
            dialogDetail:false,
            src:'',
            dialog:false,
            snackbar:  false,
            snackBarText: '',
            srcDocPDF: `${process.env.VUE_APP_BACKEND_HOST}/contratos/${this.ticket}/adjuntos/ContratoOriginal.pdf`,
            isPosting:  false,
            ticketLog:  [],
            infoTicket:{},
            userName:'',
            idUsuer:'',
            namespace:'oidcStore/',
            customer: {
                'idCustomer': 0,
                'name': '',
                'address': '',
                'phoneNumer': '',
                'regiterDate': ''
            },
            detail: {
                'idDetail': 0,
                'idTravel': 0,
                'po': '',
                'description': '',
                'truck': '',
                'trailer': '',
                'driver': '',
                authorizedBy:'',
                OtherField:'',
                OtherFieldValue:''
            },
            fab: false,
            hidden: false,
            tabs: null,
            sheet: false,
            rules: [
                value => !value || value.size < 2000000 || 'Avatar size should be less than 2 MB!',
            ],
            files: [],
            Workers:[],
            filesTicket:[],
            loading3: false,
            comentary:'',
            comentaryTravel:{},
            isWorker:false,
            isDoing:false,
            isTodo:false
        }
    },
    components:{
        'showImg':showImg
    },
    computed: {
        RegisterDate(val){
            return moment(this.infoTicket.registerDate).format('LLL')
        }
    },
    props:{
        ticket: String,
        idTravelWorker: String
    },
    created() {
        
        this.getTicketData() 
    },
    mounted(){
        this.getUserName()
    },
    methods: {
        async updateDetail(){
            this.detail.idTravel = this.ticket
            const response = await this.$store.dispatch('updateDetail', this.detail)
            if(response.status === 200){
                this.dialogDetail=false
                this.getTicketData()
                showMessageSuccess('Updated successfully')
            }else{
                this.dialogDetail=false
                showMessageWarning('not updated')
            }
        },
        showImg(val){
            this.dialog=!this.dialog
            this.src = val
        },

        async save(){
            this.loading3=true
            var data = new FormData()
            data.append('Comentary',this.comentary)
            data.append('IdTravel', this.detail.idTravel)
            data.append('idTravelWorker', this.infoTicket.tickeLogDTOs[0].idTravelWorker)
            this.files.forEach(img =>  data.append('Images', img))

            const response = await this.$store.dispatch('finishTask',data)

            if(response.status === 200){
                showMessageSuccess('Good !','Task completed successfully')
                this.comentary=''
                this.files=[]
                this.$router.push('/kanban')
            }else{
                showMessageError('An error has occurred')
            }
            this.loading3=false
        },

        async startTask(){
            var data = {idTravel:this.ticket,idTravelWorker:this.idTravelWorker}
            const response = await this.$store.dispatch('moveTicket',data)
            if(response){
                if(response.status === 200){
                    showMessageSuccess('Job started')
                    this.$router.push('/kanban')
                }else{
                    showMessageError('An error has occurred')    
                }
            }else{
                showMessageError('An error has occurred')
            }
        },

        finishTask(){
            this.sheet=true
        },
        RegisterDateLog (val){
            return moment(val).format('LLL')
        },
        getRandomColor() {
            var letters = '0123456789ABCDEF';
            var color = '#';
            for (var i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
            }
            return color;
        },
        getUserName(){
            const user = this.$store.getters[this.namespace + 'oidcUser'];
            if(user.role==='Worker')
            {
                this.isWorker = true
            }else{this.isWorker=false}
            this.userName = user.name;
            this.idUsuer = user.sub;
        },
        dateFormat(value) {
            //console.log('value ===> ', value)
            return format(value, 'DD-MM-YYYY hh:mm:ss aa')
        },
        async getTicketData(){
            const user = this.$store.getters[this.namespace + 'oidcUser'];
            var data = {idTravel: this.ticket, idTravelWorker: this.idTravelWorker}
            //console.log('data ===> ', data)
            const response = await this.$store.dispatch('getServiceByid',data)
            if(response.status === 200){
                this.infoTicket= response.data
                this.customer = response.data.customer
                this.detail = response.data.travelDetail
                this.filesTicket = response.data.filesTravel
                this.Workers = response.data.travelWorkers
                response.data.travelWorkers.forEach(e => {
                    if(user.name.toUpperCase() === e.name.toUpperCase() && e.idState === 1){
                        this.isTodo=true
                    }else{
                        this.isTodo=false
                    }
                });
                if(response.data.travelWorkers[0].idState === 2){
                    this.isDoing=true
                }else{this.isDoing=false}
            }else{
                showMessageError('An error has ocurred')
            }
        } 
    },   
} 
</script>
<style>
    .center-text {
        vertical-align: middle;
    }
    create .v-speed-dial {
        position: absolute;
    }

    #create .v-btn--floating {
        position: relative;
    }

    .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .orders-layout {
        height: 540px;
        overflow: auto;
    }
    .subTitle-card {
        margin-left: 22px;
    }
    .icon-card {
        max-width: 20px;
        max-height: 20px;
    }
</style>


